<template>
  <i-ep-delete />
</template>
